import {
  put, call, select,
} from 'lib/redux';
import i18n from 'i18n';

import validateSRSCustomerService from 'services/validateSRSCustomer.service';

import { getInitParametersSaga } from 'features/userData/UserData.saga';

import {
  validateSRSBillingAffiliatedCustomerStart, validateSRSBillingAffiliatedCustomerSuccess, validateSRSBillingAffiliatedCustomerError,
  setShowMap, validateSRSBranchEmployeeStart, validateSRSBranchEmployeeSuccess, validateSRSBranchEmployeeError,
  updateSRSBranchEmployeeErrorInfoForDisplay, srsBranchEmployeeEmptySubmission, updateSRSBranchEmployeeErrorInfo,
  validateSRSBranchEmployeeReset,
} from '../../Order.actions';

export function* validateSRSBillingAffiliatedCustomerSaga() {
  yield call(getInitParametersSaga);
  yield put(validateSRSBillingAffiliatedCustomerStart());
  try {
    const customerId = yield select(({ userData: { initParameters } }) => initParameters.customerId);
    const response = yield call(validateSRSCustomerService, true, customerId);
    if (!response.ok) {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
    yield put(validateSRSBillingAffiliatedCustomerSuccess(response.json));
  } catch (error) {
    yield put(validateSRSBillingAffiliatedCustomerError());
    yield put(setShowMap(false));
  }
}

export function* validateSRSBranchEmployeeSaga() {
  yield put(validateSRSBranchEmployeeReset());
  try {
    const {
      customerId,
      srsBranchEmployeeInfo,
      srsBranchEmployeeInfoErrors,
    } = yield select(({ userData: { initParameters }, srs: { srsBranchEmployee } }) => ({
      customerId: initParameters.customerId,
      srsBranchEmployeeInfo: srsBranchEmployee.srsBranchEmployeeInfo,
      srsBranchEmployeeInfoErrors: srsBranchEmployee.srsBranchEmployeeInfoErrors,
    }));

    if (Object.keys(srsBranchEmployeeInfo).some((field) => srsBranchEmployeeInfo[field] === '')) {
      yield put(srsBranchEmployeeEmptySubmission());
      return;
    }

    if (Object.values(srsBranchEmployeeInfoErrors).some((error) => error.length > 0)) {
      yield put(updateSRSBranchEmployeeErrorInfoForDisplay());
      return;
    }
    yield put(validateSRSBranchEmployeeStart());
    const { srsCustId, srsShipNumber } = srsBranchEmployeeInfo;
    const response = yield call(validateSRSCustomerService, false, customerId, srsCustId, Number(srsShipNumber));
    if (response.ok) {
      yield put(validateSRSBranchEmployeeReset());
      yield put(validateSRSBranchEmployeeSuccess(response.json));
      return;
    }
    let errorFromService = null;
    if (response.json.errorCode === 15573) {
      yield put(updateSRSBranchEmployeeErrorInfo(
        'srsCustId',
        i18n.t('common__field_invalid'),
        i18n.t('order__srs_branch_employee__customer_id_invalid'),
      ));
    } else if (response.json.errorCode === 15574) {
      yield put(updateSRSBranchEmployeeErrorInfo(
        'srsShipNumber',
        i18n.t('common__field_invalid'),
        response.json.errorDescription,
      ));
    } else if (response.json.errorCode === 15575) {
      errorFromService = i18n.t('order__srs_branch_employee__unauthorized');
    } else {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
    yield put(updateSRSBranchEmployeeErrorInfoForDisplay());
    yield put(validateSRSBranchEmployeeError(errorFromService));
  } catch (error) {
    yield put(validateSRSBranchEmployeeError(i18n.t('order__srs_branch_employee__error_message')));
    yield put(setShowMap(false));
  }
}
